import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleLeftSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-simple-left-square" maskId="round-filled-radius-1-stroke-1.5-IconSidebarSimpleLeftSquare"><path fillRule="evenodd" clipRule="evenodd" d="M9 4.5V19.5H19.25C19.3881 19.5 19.5 19.3881 19.5 19.25V4.75C19.5 4.61193 19.3881 4.5 19.25 4.5H9ZM3 4.75C3 3.7835 3.7835 3 4.75 3H19.25C20.2165 3 21 3.7835 21 4.75V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V4.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarSimpleLeftSquare;
